import styled from 'styled-components';

export const DocumentCheckCardContainerStyled = styled.div`
    display: inline-block;
    background-color: var(--color-surface-secondary);
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    height: 112px;
    width: 144px;
`;

export const DocumentCheckSignStyled = styled.div`
    position: absolute;
    bottom: 12px;
    right: 12px;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: var(--color-surface-secondary);
    
    svg {
        top: -5px;
        left: -5px;
        position: relative;
    }
`;

export const DocumentCheckErrorBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #FF646C1A;
    border-radius: 8px;
`
